/*  Shared  */
import { Rank } from 'application/Shared/Components/Usage';

/*  React  */
import React from 'react';

export const RankCell = (props) => {
    const { row, ...rest } = props;
    return (
        <Rank
            usage={row.original.usage}
            ranking={row.original.ranking}
            {...rest}
        />
    );
};
